import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TextService {

  private locale: string = 'en';

  constructor() { }

  /**
 * Get the list of texts in JSON format
 * @param page Page Current
 */
  get(page: string = 'all') {
    const locale = this.getLocale();
    const list = this.getData();
    return this.filter(page, list, locale);
  }

  /**
   * Set locale
   * @param locale Language 'en' , 'es', etc
   */
  setLocale(locale: string = 'en') {
    this.locale = locale;
  }

  /**
  * Get Locale language
  */
  private getLocale(): string {
    return this.locale;
  }

  /**
  * Get the data from the DB
  */
  private getData(): any[] {
    let data = {
      menu_home: {
        es: 'Inicio',
        en: 'Home',
      },
      menu_how_work: {
        es: 'Como trabajamos'
      },
      menu_advantage: {
        es: 'Beneficios'
      },
      info: {
        es: 'Localiza los negocios más cerca a ti, elige tus productos y te lo llevamos a la puerta de tu casa <span class="bold">GRATIS</span>'
      },
      soon: {
        es: 'Muy Pronto!'
      },
      how_work: {
        es: 'Como <span class="primary bold">trabajamos</span>'
      },
      advantage: {
        es: 'Nuestros <span class="primary bold">beneficios</span>'
      },
      download: {
        es: 'Próximamente en:'
      }
    };

    let work = {
      title_1: {
        es: 'Descarga Domo'
      },
      text_1: {
        es: 'Disponible en App Store y Play Store'
      },
      title_2: {
        es: 'Escoge la tienda'
      },
      text_2: {
        es: 'Encuentra las tiendas más cercanas a ti'
      },
      title_3: {
        es: 'Selecciona tus productos'
      },
      text_3: {
        es: 'Abarrotes, bebidas y todo lo que necesites'
      },
      title_4: {
        es: 'Recíbelo en la puerta de tu casa'
      },
      text_4: {
        es: 'Recibe tu pedido en menos tiempo'
      }
    };

    let advantage = {
      title_1: {
        es: 'Variedad'
      },
      text_1: {
        es: 'Conoce los locales cerca de ti'
      },
      title_2: {
        es: 'Menos tiempo'
      },
      text_2: {
        es: 'Recibe tus pedidos en tiempo record'
      },
      title_3: {
        es: 'Todo el año'
      },
      text_3: {
        es: 'Delivery <span class="bold">GRATIS</span>'
      },
    };

    let lover = {
      title: {
        es: 'DOMO <span class="bold primary">LOVER</span>'
      },
      text: {
        es: 'Localiza los negocios que se encuentran más cerca de ti, elige tus productos y te lo llevamos a la puerta de tu casa <span class="bold">GRATIS!</span>'
      },
      button: {
        es: 'Muy Pronto'
      }
    };

    let business = {
      title: {
        es: 'DOMO <span class="bold primary">BUSINESS</span>'
      },
      text: {
        es: 'Registra tu negocio y haz que más personas te conozcan.<br><br>Únete a la familia DOMO y duplica tus ventas YA!'
      },
      button: {
        es: 'Muy Pronto'
      }
    };

    let footer = {
      info: {
        es: 'Todos los derechos reservados, Domo '
      },
      terms: {
        es: 'Términos y Condiciones'
      },
      privacy: {
        es: 'Política de privacidad'
      }
    };

    return [
      {
        uid: 'all', data: data
      },
      {
        uid: 'work', data: work
      },
      {
        uid: 'advantage', data: advantage
      },
      {
        uid: 'lover', data: lover
      },
      {
        uid: 'business', data: business
      },
      {
        uid: 'footer', data: footer
      }
    ];
  }

  /**
  * Filter data of texts
  * @param page Page to Filter
  * @param list List of texts
  * @param locale Locale user
  */
  private filter(page: string, list: any[], locale: string) {

    let data_page = list.find(l => l.uid === page) || { data: {} };

    let list_aux = {
      ...list.find(l => l.uid === 'all').data,
      ...data_page.data
    };

    return this.translate(list_aux, locale);
  }

  /**
   * Filter by locale
   * @param list List of texts
   * @param locale Locale user
   */
  private translate(list: any[], locale: string) {
    let list_aux = {};

    for (const key in list) {
      const text_object = list[key];
      list_aux[key] = text_object[locale] || text_object['en'];
    }

    return list_aux;
  }

}
